import { useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCredentials, signout, userTokenSelector } from '../redux/appSlice';
import { rootNavigationRef } from '../navigation/rootNavigationRef';
import { dateWithNoTimeDashed } from '../utils/date';
import { SCREENSHOT_SCREEN } from './index';
import { SCREENSHOT_TODAY_LUNCH, screenshotTodayDayType } from './fixtures';
const FAKE_TOKEN = 'screenshot-mode';
const FAR_FUTURE = Date.now() + 365 * 24 * 60 * 60 * 1000;
/**
 * Rendered only in screenshot mode (inside PersistGate, so after rehydrate).
 * Fakes a session (or signs out for the Sign in shot) and pushes the
 * requested screen on top of Home so the header shows a normal back button.
 */
export const ScreenshotBootstrap = () => {
    const dispatch = useDispatch();
    const userToken = useSelector(userTokenSelector);
    useLayoutEffect(() => {
        if (SCREENSHOT_SCREEN === 'signin') {
            dispatch(signout());
        }
        else {
            dispatch(setCredentials({
                token: FAKE_TOKEN,
                refreshToken: FAKE_TOKEN,
                tokenExpires: FAR_FUTURE,
            }));
        }
    }, [dispatch]);
    useEffect(() => {
        if (!userToken || SCREENSHOT_SCREEN === 'signin' || SCREENSHOT_SCREEN === 'home') {
            return;
        }
        const dateStr = dateWithNoTimeDashed(new Date());
        let tries = 0;
        const timer = setInterval(() => {
            tries += 1;
            if (!rootNavigationRef.isReady()) {
                if (tries > 50) {
                    clearInterval(timer);
                }
                return;
            }
            clearInterval(timer);
            const nav = rootNavigationRef;
            switch (SCREENSHOT_SCREEN) {
                case 'meal-map':
                    nav.navigate('MealMap', { dateStr });
                    break;
                case 'meal-entry':
                    nav.navigate('MealMap', { dateStr });
                    nav.navigate('MealEntry', {
                        dateStr,
                        mealType: 'lunch',
                        dayType: screenshotTodayDayType(),
                        entryId: SCREENSHOT_TODAY_LUNCH.entryId,
                        initialDescription: SCREENSHOT_TODAY_LUNCH.description,
                        initialConsumedTime: SCREENSHOT_TODAY_LUNCH.consumedTime,
                        initialEstimatedCalories: SCREENSHOT_TODAY_LUNCH.estimatedCalories,
                    });
                    break;
                case 'water':
                    nav.navigate('Water', { dateStr });
                    break;
                case 'weigh-in':
                    nav.navigate('WeighIn', { dateStr });
                    break;
                case 'exercise':
                    nav.navigate('Exercise', { dateStr });
                    break;
            }
        }, 100);
        return () => clearInterval(timer);
    }, [userToken]);
    return null;
};
